import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { DISCOUNT_CODE_MESSAGES } from '#pplx/frontend/apps/ask/subscription/constants.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
export const useDiscountCode = () => {
    const [partnerLogoLight, setPartnerLogoLight] = useState(null);
    const [partnerLogoDark, setPartnerLogoDark] = useState(null);
    const router = useRouter();
    const query = useSearchParams();
    const pathname = usePathname();
    const discount_code = query?.get('discount_code');
    const { $t } = useIntl();
    const codeToUse = Array.isArray(discount_code) ? discount_code[0] : discount_code;
    const [discountCode, setDiscountCode] = useState(codeToUse || null);
    const { hasAccessToProFeatures } = useIsSubscribed();
    const clearDiscountCode = useCallback(() => {
        setPartnerLogoDark(null);
        setPartnerLogoLight(null);
        setDiscountCode(null);
    }, []);
    const getPartnerImage = useCallback((code) => {
        if (partnerLogoDark && partnerLogoLight) {
            return;
        }
        if (code?.startsWith('REPLIT')) {
            setPartnerLogoLight('/static/images/replit.svg');
            setPartnerLogoDark('/static/images/replit_dark.svg');
        }
        else if (code?.startsWith('BREX')) {
            setPartnerLogoLight('/static/images/brex.svg');
            setPartnerLogoDark('/static/images/brex_dark.svg');
        }
        else {
            setPartnerLogoDark(null);
            setPartnerLogoLight(null);
        }
    }, [partnerLogoDark, partnerLogoLight]);
    useEffect(() => {
        if (hasAccessToProFeatures || !codeToUse) {
            return;
        }
        setDiscountCode(codeToUse);
        getPartnerImage(codeToUse);
        if (pathname === '/pro') {
            router.push(routes['/'].href(), undefined, 'Pro page');
        }
    }, [codeToUse, getPartnerImage, hasAccessToProFeatures, pathname, router]);
    const getCustomMessage = useCallback((discountCode) => {
        for (const code in DISCOUNT_CODE_MESSAGES) {
            if (discountCode && discountCode.startsWith(code)) {
                return DISCOUNT_CODE_MESSAGES[code];
            }
        }
        return $t({
            defaultMessage: 'Redeem your promo code {discountCode}. Get started',
            description: 'Message shown to users with a discount code prompting them to redeem it',
            id: '7667365b9d',
        }, { discountCode });
    }, [$t]);
    return useMemo(() => ({
        discountCode,
        setDiscountCode,
        partnerLogoDark,
        partnerLogoLight,
        message: getCustomMessage(discountCode ?? ''),
        clearDiscountCode,
    }), [clearDiscountCode, discountCode, getCustomMessage, partnerLogoDark, partnerLogoLight]);
};
//# sourceMappingURL=useDiscountCode.js.map